<p-button
  size="small"
  severity="contrast"
  variant="text"
  [disabled]="disabled()"
  (click)="onMenuOpen($event)"
>
  <ng-template #icon>
    <svg-icon
      class="text-french-blue-600"
      src="/assets/icons/general/document-no-text.svg"
    />
  </ng-template>
</p-button>

<p-popover
  #queueMenuPopover
  (onHide)="onMenuClose()"
  styleClass="[&_.p-popover-content]:p-0!"
>
  <div class="max-w-85">
    <div class="relative flex max-h-12 items-center border-b px-1 py-1.5">
      <span class="truncate pl-2 pr-8 text-sm font-semibold">
        {{ title() }}
      </span>

      <p-button
        size="small"
        class="absolute right-1 top-2"
        variant="text"
        severity="contrast"
        pTooltip="Close"
        tooltipPosition="left"
        (click)="onCloseQueueMenu()"
      >
        <ng-template #icon>
          <svg-icon src="/assets/icons/general/close.svg" />
        </ng-template>
      </p-button>
    </div>

    @if (queueItems()?.length) {
      <ng-container *ngTemplateOutlet="mainTemplate" />
    }

    @if (!queueItems()?.length && customEmptyStateTemplateRef()) {
      <ng-container *ngTemplateOutlet="customEmptyStateTemplateRef()" />
    }
  </div>
</p-popover>

<ng-template #mainTemplate>
  <div class="my-1 grid max-h-64 grid-cols-1 gap-1 overflow-y-auto">
    @for (queueItem of queueItems(); track queueItem; let index = $index) {
      <div>
        <ag1-queue-item
          [queueItem]="queueItem"
          (itemClickEvent)="onItemClick($event)"
        />
      </div>
    }
  </div>
</ng-template>
